import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/autoplay';
import { Autoplay } from 'swiper/modules';
import { FaUserCircle } from "react-icons/fa";

function PartnerTestimonialsSection() {
 const testimonials =[
  {
    name: "Aarav Sharma",
    role: "HR Consultant at PeopleFirst India",
    quote: "SelfSync gave me a revenue-ready business in 3 weeks."
  },
  {
    name: "Ritika Nair",
    role: "Entrepreneur at Zenith Growth",
    quote: "I now serve 20+ clients — all under my brand. No tech headaches."
  },
  {
    name: "Priya Mehra",
    role: "Marketing Director at BrandSphere",
    quote: "SelfSync helped us scale outreach without doubling our headcount."
  },
  {
    name: "Kabir Iyer",
    role: "chief marketing officer at CloudBridge Technologies",
    quote: "We reduced onboarding time by 70% thanks to SelfSync’s platform."
  },
  {
    name: "Ananya Desai",
    role: "Founder at TalentNet India",
    quote: "A game-changer for consultants. My clients think it’s my own SaaS."
  },
  {
    name: "Rahul Menon",
    role: "Strategy Consultant at NovaEdge",
    quote: "No-code backend, instant results. SelfSync is a secret weapon."
  },
  {
    name: "Sneha Kapoor",
    role: "Leadership Coach at ClarityPath",
    quote: "Clients love the polished experience. I love the automation."
  },
  {
    name: "Vikram Sethi",
    role: "Sales Trainer at MentorHub",
    quote: "I finally feel in control of my tech — without needing a dev."
  },
  {
    name: "Farah Qureshi",
    role: "Freelance Consultant at ThinkSuite",
    quote: "SelfSync saved me hours of setup every week."
  },
  {
    name: "Aditya Verma",
    role: "Operations Lead at QuickPivot India",
    quote: "Reliable, fast, and easy to white-label. Highly recommend it!"
  }
];

  return (
    <section className="bg-white py-16 max-md:py-12 px-4 border-t border-b border-violet-100">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-3xl font-bold text-center mb-12">
          What Our Partners Say
        </h2>

        <Swiper
          modules={[Autoplay]}
          spaceBetween={24}
          slidesPerView={3}
          loop={true}
          autoplay={{
            delay: 5000,
            disableOnInteraction: false,
          }}
          breakpoints={{
            320: { slidesPerView: 1 },
            640: { slidesPerView: 2 },
            1024: { slidesPerView: 3 },
          }}
          className="pb-4"
        >
          {testimonials.map((t, i) => (
            <SwiperSlide key={i} className="max-w-sm bg-white p-6 rounded-xl border border-violet-200 shadow-sm">
              <blockquote className="text-lg italic mb-4 text-violet-800">
                "{t.quote}"
              </blockquote>
              <div className="flex items-center">
                <div className="rounded-full mr-4">
                  <FaUserCircle size={30} className='text-violet-200' />
                </div>
                <div>
                  <p className="font-semibold text-violet-800">{t.name}</p>
                  <p className="text-violet-600 text-sm">{t.role}</p>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
}

export default PartnerTestimonialsSection;
